import { FilterState } from '@/app/(main)/(pages)/busca/[slug]/_types/filter-state.type';

export const SearchFilterParamKey: Record<keyof FilterState, string> = {
  orderBy: 'orderBy',
  dayTime: 'dayTime',
  professionalGender: 'professionalGender',
  distance: 'distance',
  minDate: 'startDate',
  maxDate: 'endDate',
  followUp: 'followUp',
  onlyScheduled: 'onlyScheduled',
  ageGroup: 'ageGroup',
};
